/* RESPONSIBLE TEAM: team-automation-foundations */
import ContentController from 'embercom/controllers/apps/app/automation/fin-ai-agent/content';

export default class EcommerceContentController extends ContentController {}
